const state = {
  dictMap: {
    SEX_TYPE: [
      {
        name: '男士',
        value: '1',
      },
      {
        name: '女士',
        value: '2',
      },
      {
        name: '未知',
        value: '0',
      },
    ],
    PUBLISH_STATUS: [
      {
        name: '草稿',
        value: 'DRAFT',
      },
      {
        name: '已发布',
        value: 'PUBLISHED',
      },
      {
        name: '撤销发布',
        value: 'PUBLISH_CANCELED',
      },
      {
        name: '预约发布',
        value: 'PUBLISHE_WAIT',
      },
    ],
    LOGIN_LOG_TYPE: [
      {
        name: '全部',
        value: '',
      },
      {
        name: '登入',
        value: 0,
      },
      {
        name: '登出',
        value: 1,
      },
    ],
  },
};

const mutations = {};

const actions = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
